module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 31.3b002b50.png";